import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './modules/user';
import route from './modules/route';
import playlist from './modules/playlist';
import presearch from './modules/presearch';
import player from './modules/player';
import discover from './modules/discover';
import episodes from './modules/episodes';
import library from './modules/library';
import subscription from './modules/subscription';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    route: state.route,
    playlist: {
      playlistType: state.playlist.playlistType,
    },
    library: state.library,
  }),
});

export default new Vuex.Store({
  modules: {
    user,
    route,
    playlist,
    presearch,
    player,
    discover,
    episodes,
    subscription,
    library,
  },
  plugins: [vuexLocalStorage.plugin],
});



// WEBPACK FOOTER //
// ./app/src/store/index.js